import { MessageCircle } from 'lucide-react';
import { useEffect, useState } from 'react';
import { settingsAPI } from '../lib/api';
import { useApiQuery } from '../hooks/useApiQuery';
import { WhatsAppIcon } from './WhatsAppIcon';

export const WhatsAppButton = ({ productName = null }) => {
  const { data: settingsRes } = useApiQuery(
    ['settings'],
    () => settingsAPI.get()
  );

  const whatsappNumber = settingsRes?.data?.whatsapp_number || '1234567890';

  const getMessage = () => {
    if (productName) {
      return `Hello, I'm interested in ${productName}. Can you provide more details?`;
    }
    return 'Hello, I would like to inquire about your products.';
  };

  const handleClick = () => {
    const message = encodeURIComponent(getMessage());
    const url = `https://wa.me/${whatsappNumber}?text=${message}`;
    window.open(url, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      data-testid="whatsapp-button"
      className="whatsapp-float wa-pulse bg-white text-white p-1 rounded-full shadow-xl hover:scale-110 transition-all"
    >
      <WhatsAppIcon className="w-12 h-12" />
    </button>
  );
};
